import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateCardEntity } from '../../domain/entities/CreateUpdateCardEntity'

export class CreateUpdateCardModel extends CreateUpdateCardEntity {
  channelId?: number
  branchTagIds?: number[]
  constructor(dataDto: CreateUpdateCardEntity) {
    super()
    mapEntityProperties<CreateUpdateCardModel>(this, dataDto, {
      exclude: ['regions', 'channel', 'branchTags'],
      map: {
        branchTagIds: dataDto.branchTags?.map((item) => item.id),
        channelId: dataDto.channel?.id,
        cardRegions: dataDto.cardRegions?.map((item) => {
          return {
            regionId: item.region?.id,
            districtIds: item.districtIds
          }
        })
      }
    })
  }
}
